import React, { useState } from 'react'

import { Button } from 'antd'
import Profile from '../../../../core/components/profile'
import { LAYOUT_ADMIN_SERVICE_EDIT } from '../../navigation'
import { EditOutlined } from '@ant-design/icons'

import { usePostFormCategory, usePutFormCategory, useRemoveCategory, useFetch } from '../../../../hooks/admin/service'
import { Link, useHistory, useParams } from 'react-router-dom'
import Loader from '../../../../components/loader'

import FormCategory from './formCategory'
import Information from './information'
import Categories from './categories'

const Show = () => {
  const { id } = useParams()
  const { data, isLoading, isError } = useFetch(id)
  const { mutate: createCategory, isLoading: isCreateLoading } = usePostFormCategory(id)
  const { mutate: updateCategory, isLoading: isUpdateLoading } = usePutFormCategory(id)
  const { mutate: removeCategory, isLoading: isRemoveLoading } = useRemoveCategory(id)
  const actionLoading = isCreateLoading || isUpdateLoading || isRemoveLoading
  const history = useHistory()

  const [editMode, setEditMode] = useState(false)
  const [category, setCategory] = useState(null)
  const [modalVisible, setModalVisible] = useState(false)
  const showModal = () => setModalVisible(true)
  const hideModal = () => setModalVisible(false)

  const onPressBack = () => history.goBack()

  const showCreateModal = () => {
    setCategory(null)
    setEditMode(false)
    showModal()
  }

  const showUpdateModal = (id) => {
    const category = (data.categories || []).find((item) => item.id === id)
    setCategory(category)
    setEditMode(true)
    showModal()
  }

  if (isLoading) {
    return (<Loader loading={isLoading} />)
  }

  if (isError) {
    return (<>Error</>)
  }

  return (
    <>
      <Profile
        onBack={onPressBack}
        mainTitle='Services'
        ainSubtitle='subtitle'
        mainExtra={[
          <Link key='service.update' to={LAYOUT_ADMIN_SERVICE_EDIT(data.id)}>
            <Button type='primary' size='small' icon={<EditOutlined />}>
              Update
            </Button>
          </Link>
        ]}
        renderInformation={() => <Information entidad={data} />}
      >
        <h2 className='after-underline'>Allowed Units</h2>
        <ul>
          {(data.units || []).map((item) => (
            <li key={item.id.toString()}>{item.name}</li>
          ))}
        </ul>
        <br />
        <h2 className='after-underline'>Categories</h2>
        <br />
        <br />
        <Categories
          actionLoading={actionLoading}
          list={data.categories}
          createCategory={showCreateModal}
          updateCategory={showUpdateModal}
          deleteCategory={removeCategory}
        />
        {modalVisible && (
          <FormCategory
            edit={editMode}
            category={category}
            createAction={createCategory}
            updateAction={updateCategory}
            onCancel={hideModal}
            modalVisible={modalVisible}
          />
        )}
      </Profile>
    </>
  )
}

export default Show
